import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import AddToBatchSelectForm from "containers/admin/clients/client/approval-queue/components/add-to-batch-select-form/add-to-batch-select-form";

export type AddToBatchModalProps = {
  onCloseCallback: () => void;
  onConfirmCallback: (values: { batchId: string }, batchName?: string) => void | Promise<void>;
  latestBatchId?: string;
  isLatestBatchLoading?: boolean;
  versionBatchId?: string;
  isSubmitting?: boolean;
  title?: string;
  submitButtonLabel?: string;
  submittingLabel?: string;
};

const AddToBatchModal = ({
  onCloseCallback,
  onConfirmCallback,
  latestBatchId,
  isLatestBatchLoading = false,
  versionBatchId,
  isSubmitting = false,
  title = "Add to batch",
  submitButtonLabel = "Add to batch",
  submittingLabel = "Adding to batch...",
}: AddToBatchModalProps) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const form = useForm<{ batchId: string }>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues: { batchId: "" },
  });

  useEffect(() => {
    setIsSubmitDisabled(true);
    setSelectedBatchName("");
  }, []);

  const handleConfirm = async (values: { batchId: string }) => {
    await onConfirmCallback(values, selectedBatchName);
  };

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline={title}
      form={form}
      onSubmit={handleConfirm}
      submitDisabled={isSubmitDisabled}
      submitting={isSubmitting}
      submitButtonText={submitButtonLabel}
      submitLoadingMessage={submittingLabel}>
      <AddToBatchSelectForm
        versionBatchId={versionBatchId}
        latestBatchId={latestBatchId}
        isLatestBatchLoading={isLatestBatchLoading}
        setIsSubmitDisabled={setIsSubmitDisabled}
        onBatchIdChange={(_batchId, batchName) => setSelectedBatchName(batchName ?? "")}
      />
    </FormDialog>
  );
};

export default AddToBatchModal;
